import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { PatientCareCenterNoteNavAnchor, PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './MedHistoryPeds.module.css';
import { DBCheckBox, DBRadioButton, DBTextArea, DBIntField, DBDropDown, DBTextField } from '_components';
import { PatientCareCenterNoteSubjectiveFunctionalDeficits } from './FunctionalDeficits';

class PatientCareCenterNoteSubjectiveMedHistoryPeds extends React.Component {

    handleClick(selected) {
        if (selected) {
            let fields = ['EVPSUBMEDCOMADHD',
                'EVPSUBMEDCOMANEMIA',
                'EVPSUBMEDCOMANXIETY',
                'EVPSUBMEDCOMARTHITIS',
                'EVPSUBMEDCOMASTHMA',
                'EVPSUBMEDCOMAUTISM',
                'EVPSUBMEDCOMHEADACHES',
                'EVPSUBMEDCOMHEARING',
                'EVPSUBMEDCOMHEART',
                'EVPSUBMEDCOMHIGHBLOOD',
                'EVPSUBMEDCOMHYPERTONIA',
                'EVPSUBMEDCOMHYPOTONIA',
                'EVPSUBMEDCOMKIDNEY',
                'EVPSUBMEDCOMCANCER',
                'EVPSUBMEDCOMCEREBRAL',
                'EVPSUBMEDCOMCONSTIPATION',
                'EVPSUBMEDCOMDEPRESSION',
                'EVPSUBMEDCOMDIABETES',
                'EVPSUBMEDCOMEPILEPSY',
                'EVPSUBMEDCOMMUSCULAR',
                'EVPSUBMEDCOMREFLUX',
                'EVPSUBMEDCOMSPINA',
                'EVPSUBMEDCOMSTROKE',
                'EVPSUBMEDCOMTHYROID',
                'EVPSUBMEDCOMVISION'
            ];
            this.props.clearFields(this.props.noteId, 'PTEVALPEDS', 'EVPNO', this.props.evpno, fields);
        }
    }

    handleMedsClick(selectedVal) {
        if (selectedVal === undefined || selectedVal === false) {
            this.props.clearFields(this.props.noteId, 'PTEVAL', 'EVNO', this.props.evno, ['EVSUBMEDCURRENT', 'EVSUBMEDS']);
        }
    }


    render() {
        return (
            <div>
                <div className={styles.table}>
                    <PatientCareCenterNoteNavAnchor id='sub_med_hist_peds_place' />
                    <div className={styles.rows}>
                        <label className={styles.label_col_info}>Place of service</label>
                        <div className={styles.info_field}>
                            <DBDropDown
                                className={styles.service_drop_down}
                                noteId={this.props.noteId}
                                entity='PTEVALPEDS'
                                entityKeyColumn='EVPNO'
                                entityKeyValue={this.props.evpno}
                                field='EVPINFOPLACEOFSERVICE'
                                masterEntity='PTMASTERPLACEOFSERVICE'
                                masterEntityKeyColumn='POSNO'
                                masterEntitySort='POSORDER'
                                masterEntityDisplay='POSDESC'
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.table}>
                    <div className={styles.rows}>
                        <label className={styles.peds_label}>CNDS Number</label>
                        <div className={styles.peds_field_wrapper}>
                            <DBTextField
                                className={styles.peds_field}
                                noteId={this.props.noteId}
                                entity='PTEVALPEDS'
                                entityKeyColumn='EVPNO'
                                entityKeyValue={this.props.evpno}
                                field='EVPSUBPEDCNDS'
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.table}>
                    <div className={styles.rows}>
                        <label className={styles.peds_label}>Service Coordinator</label>
                        <div className={styles.peds_field_wrapper}>
                            <DBTextField
                                className={styles.peds_field}
                                noteId={this.props.noteId}
                                entity='PTEVALPEDS'
                                entityKeyColumn='EVPNO'
                                entityKeyValue={this.props.evpno}
                                field='EVPSUBPEDSERVICECOORD'
                            />
                        </div>
                    </div>
                </div>



                <PatientCareCenterNoteSection id='sub_med_hist_prev' name='History of Previous Treatments' level={2} allowCollapse={false} className={styles.required}>
                    <div className={styles.radio_row}>
                        <label className={styles.label_col_req_shorter}>Has the child been treated for the same condition in the past?</label>
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVALPEDS'
                            entityKeyColumn='EVPNO'
                            entityKeyValue={this.props.evpno}
                            field='EVPHISTORYPREVTREATEDPREV'
                            label='Yes'
                            selectedValue={true}
                            className={styles.radio_col}
                        />
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVALPEDS'
                            entityKeyColumn='EVPNO'
                            entityKeyValue={this.props.evpno}
                            field='EVPHISTORYPREVTREATEDPREV'
                            label='No'
                            selectedValue={false}
                            className={styles.radio_col}
                        />
                    </div>

                    {this.props.prevTreat &&
                        <div className={styles.radio_row}>
                            <label className={styles.label_col_req_shorter}>Did the previous treatment help?</label>
                            <DBRadioButton
                                noteId={this.props.noteId}
                                entity='PTEVALPEDS'
                                entityKeyColumn='EVPNO'
                                entityKeyValue={this.props.evpno}
                                field='EVPHISTORYPREVTREATEDPREVHELP'
                                label='Yes'
                                selectedValue={true}
                                className={styles.radio_col}
                            />
                            <DBRadioButton
                                noteId={this.props.noteId}
                                entity='PTEVALPEDS'
                                entityKeyColumn='EVPNO'
                                entityKeyValue={this.props.evpno}
                                field='EVPHISTORYPREVTREATEDPREVHELP'
                                label='No'
                                selectedValue={false}
                                className={styles.radio_col}
                            />
                        </div>
                    }
                    <div className={styles.rows}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPHISTORYPREVEARLYINT' label='Early Intervention/Birth-to-Three' className={styles.checkbox_col} />
                        {this.props.earlyInter &&
                            <>
                                <label className={styles.label_col_req}>Details:</label>
                                <DBTextField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTORYPREVEARLYINTDETAILS'
                                    className={styles.text_school_field}
                                    placeholder='Details'
                                />
                            </>
                        }
                    </div>
                    <div className={styles.rows}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPHISTORYPREVHOSPITAL' label='Hospital' className={styles.checkbox_col} />
                        {this.props.hosptial &&
                            <>
                                <label className={styles.label_col_req}>Details:</label>
                                <DBTextField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTORYPREVHISPITALDETAILS'
                                    className={styles.text_school_field}
                                    placeholder='Details'
                                />
                            </>
                        }
                    </div>
                    <div className={styles.rows}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPHISTORYPREVSCHOOL' label='School' className={styles.checkbox_col} />
                        {this.props.school &&
                            <>
                                <label className={styles.label_col_req}>Details:</label>
                                <DBTextField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTORYPREVSCHOOLDETAILS'
                                    className={styles.text_school_field}
                                    placeholder='Details'
                                />
                            </>
                        }
                    </div>
                    <div className={styles.rows}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPHISTORYPREVOTHER' label='Other Therapy Agency' className={styles.checkbox_col} />
                        {this.props.otherTher &&
                            <>
                                <label className={styles.label_col_req}>Details:</label>
                                <DBTextField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTORYPREVOTHERDETAILS'
                                    className={styles.text_school_field}
                                    placeholder='Details'
                                />
                            </>
                        }
                    </div>

                </PatientCareCenterNoteSection>

                <PatientCareCenterNoteSection id='sub_med_hist_dev' name='History of Development' level={2} allowCollapse={false}>
                    <div className={styles.history_checkbox_rows}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPHISTDEVSIT' label='Sit without support' className={styles.checkbox_col} />
                        {this.props.histDevSit &&
                            <>
                                Age:
                                <DBIntField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGESIT'
                                    min={0}
                                    max={20}
                                    className={styles.colAge}
                                />
                                <DBDropDown
                                    className={styles.rating_drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGETYPESIT'
                                    masterEntity='PTAGETYPES'
                                    masterEntityKeyColumn='ATNO'
                                    masterEntitySort='ATNO'
                                    masterEntityDisplay='ATDESC'
                                />
                                <div className={styles.rating_drop_down}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTEVALPEDS'
                                        entityKeyColumn='EVPNO'
                                        entityKeyValue={this.props.evpno}
                                        field='EVPHISTDEVSITCOMMENTS'
                                        placeholder='Comments'
                                    />
                                </div>
                            </>
                        }
                    </div>
                    <div className={styles.history_checkbox_rows}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPHISTDEVROLL' label='Roll' className={styles.checkbox_col} />
                        {this.props.histDevRoll &&
                            <>
                                Age:
                                <DBIntField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGEROLL'
                                    min={0}
                                    max={20}
                                    className={styles.colAge}
                                />
                                <DBDropDown
                                    className={styles.rating_drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGETYPEROLL'
                                    masterEntity='PTAGETYPES'
                                    masterEntityKeyColumn='ATNO'
                                    masterEntitySort='ATNO'
                                    masterEntityDisplay='ATDESC'
                                />
                                <div className={styles.rating_drop_down}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTEVALPEDS'
                                        entityKeyColumn='EVPNO'
                                        entityKeyValue={this.props.evpno}
                                        field='EVPHISTDEVROLLCOMMENTS'
                                        placeholder='Comments'
                                    />
                                </div>
                            </>
                        }
                    </div>
                    <div className={styles.history_checkbox_rows}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPHISTDEVCRAWL' label='Crawl' className={styles.checkbox_col} />
                        {this.props.histDevCrawl &&
                            <>
                                Age:
                                <DBIntField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGECRAWL'
                                    min={0}
                                    max={20}
                                    className={styles.colAge}
                                />
                                <DBDropDown
                                    className={styles.rating_drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGETYPECRAWL'
                                    masterEntity='PTAGETYPES'
                                    masterEntityKeyColumn='ATNO'
                                    masterEntitySort='ATNO'
                                    masterEntityDisplay='ATDESC'
                                />
                                <div className={styles.rating_drop_down}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTEVALPEDS'
                                        entityKeyColumn='EVPNO'
                                        entityKeyValue={this.props.evpno}
                                        field='EVPHISTDEVCRAWLCOMMENTS'
                                        placeholder='Comments'
                                    />
                                </div>
                            </>
                        }
                    </div>
                    <div className={styles.history_checkbox_rows}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPHISTDEVSTAND' label='Stand' className={styles.checkbox_col} />
                        {this.props.histDevStand &&
                            <>
                                Age:
                                <DBIntField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGESTAND'
                                    min={0}
                                    max={20}
                                    className={styles.colAge}
                                />
                                <DBDropDown
                                    className={styles.rating_drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGETYPESTAND'
                                    masterEntity='PTAGETYPES'
                                    masterEntityKeyColumn='ATNO'
                                    masterEntitySort='ATNO'
                                    masterEntityDisplay='ATDESC'
                                />
                                <div className={styles.rating_drop_down}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTEVALPEDS'
                                        entityKeyColumn='EVPNO'
                                        entityKeyValue={this.props.evpno}
                                        field='EVPHISTDEVSTANDCOMMENTS'
                                        placeholder='Comments'
                                    />
                                </div>
                            </>
                        }
                    </div>
                    <div className={styles.history_checkbox_rows}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPHISTDEVWALK' label='Walk' className={styles.checkbox_col} />
                        {this.props.histDevWalk &&
                            <>
                                Age:
                                <DBIntField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGEWALK'
                                    min={0}
                                    max={20}
                                    className={styles.colAge}
                                />
                                <DBDropDown
                                    className={styles.rating_drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGETYPEWALK'
                                    masterEntity='PTAGETYPES'
                                    masterEntityKeyColumn='ATNO'
                                    masterEntitySort='ATNO'
                                    masterEntityDisplay='ATDESC'
                                />
                                <div className={styles.rating_drop_down}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTEVALPEDS'
                                        entityKeyColumn='EVPNO'
                                        entityKeyValue={this.props.evpno}
                                        field='EVPHISTDEVWALKCOMMENTS'
                                        placeholder='Comments'
                                    />
                                </div>
                            </>
                        }
                    </div>
                    <div className={styles.history_checkbox_rows}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPHISTDEVRUN' label='Run' className={styles.checkbox_col} />
                        {this.props.histDevRun &&
                            <>
                                Age:
                                <DBIntField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGERUN'
                                    min={0}
                                    max={20}
                                    className={styles.colAge}
                                />
                                <DBDropDown
                                    className={styles.rating_drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGETYPERUN'
                                    masterEntity='PTAGETYPES'
                                    masterEntityKeyColumn='ATNO'
                                    masterEntitySort='ATNO'
                                    masterEntityDisplay='ATDESC'
                                />
                                <div className={styles.rating_drop_down}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTEVALPEDS'
                                        entityKeyColumn='EVPNO'
                                        entityKeyValue={this.props.evpno}
                                        field='EVPHISTDEVRUNCOMMENTS'
                                        placeholder='Comments'
                                    />
                                </div>
                            </>
                        }
                    </div>
                    <div className={styles.history_checkbox_rows}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPHISTDEVPUTWORDS' label='Put words together' className={styles.checkbox_col} />
                        {this.props.histDevWords &&
                            <>
                                Age:
                                <DBIntField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGEPUTWORDS'
                                    min={0}
                                    max={20}
                                    className={styles.colAge}
                                />
                                <DBDropDown
                                    className={styles.rating_drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGETYPEPUTWORDS'
                                    masterEntity='PTAGETYPES'
                                    masterEntityKeyColumn='ATNO'
                                    masterEntitySort='ATNO'
                                    masterEntityDisplay='ATDESC'
                                />
                                <div className={styles.rating_drop_down}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTEVALPEDS'
                                        entityKeyColumn='EVPNO'
                                        entityKeyValue={this.props.evpno}
                                        field='EVPHISTDEVPUTWORDSCOMMENTS'
                                        placeholder='Comments'
                                    />
                                </div>
                            </>
                        }
                    </div>
                    <div className={styles.history_checkbox_rows}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPHISTDEVREAD' label='Read' className={styles.checkbox_col} />
                        {this.props.histDevRead &&
                            <>
                                Age:
                                <DBIntField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGEREAD'
                                    min={0}
                                    max={20}
                                    className={styles.colAge}
                                />
                                <DBDropDown
                                    className={styles.rating_drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGETYPEREAD'
                                    masterEntity='PTAGETYPES'
                                    masterEntityKeyColumn='ATNO'
                                    masterEntitySort='ATNO'
                                    masterEntityDisplay='ATDESC'
                                />
                                <div className={styles.rating_drop_down}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTEVALPEDS'
                                        entityKeyColumn='EVPNO'
                                        entityKeyValue={this.props.evpno}
                                        field='EVPHISTDEVREADCOMMENTS'
                                        placeholder='Comments'
                                    />
                                </div>
                            </>
                        }
                    </div>
                    <div className={styles.history_checkbox_rows}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPHISTDEVFEEDSELF' label='Feed him/herself' className={styles.checkbox_col} />
                        {this.props.histDevFeed &&
                            <>
                                Age:
                                <DBIntField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGEFEEDSELF'
                                    min={0}
                                    max={20}
                                    className={styles.colAge}
                                />
                                <DBDropDown
                                    className={styles.rating_drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGETYPEFEEDSELF'
                                    masterEntity='PTAGETYPES'
                                    masterEntityKeyColumn='ATNO'
                                    masterEntitySort='ATNO'
                                    masterEntityDisplay='ATDESC'
                                />
                                <div className={styles.rating_drop_down}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTEVALPEDS'
                                        entityKeyColumn='EVPNO'
                                        entityKeyValue={this.props.evpno}
                                        field='EVPHISTDEVFEEDSELFCOMMENTS'
                                        placeholder='Comments'
                                    />
                                </div>
                            </>
                        }
                    </div>
                    <div className={styles.history_checkbox_rows}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPHISTDEVCOLOR' label='Color' className={styles.checkbox_col} />
                        {this.props.histDevColor &&
                            <>
                                Age:
                                <DBIntField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGECOLOR'
                                    min={0}
                                    max={20}
                                    className={styles.colAge}
                                />
                                <DBDropDown
                                    className={styles.rating_drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGETYPECOLOR'
                                    masterEntity='PTAGETYPES'
                                    masterEntityKeyColumn='ATNO'
                                    masterEntitySort='ATNO'
                                    masterEntityDisplay='ATDESC'
                                />
                                <div className={styles.rating_drop_down}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTEVALPEDS'
                                        entityKeyColumn='EVPNO'
                                        entityKeyValue={this.props.evpno}
                                        field='EVPHISTDEVCOLORCOMMENTS'
                                        placeholder='Comments'
                                    />
                                </div>
                            </>
                        }
                    </div>
                    <div className={styles.history_checkbox_rows}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPHISTDEVGETDRESSED' label='Get dressed' className={styles.checkbox_col} />
                        {this.props.histDevDressed &&
                            <>
                                Age:
                                <DBIntField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGEGETDRESSED'
                                    min={0}
                                    max={20}
                                    className={styles.colAge}
                                />
                                <DBDropDown
                                    className={styles.rating_drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGETYPEGETDRESSED'
                                    masterEntity='PTAGETYPES'
                                    masterEntityKeyColumn='ATNO'
                                    masterEntitySort='ATNO'
                                    masterEntityDisplay='ATDESC'
                                />
                                <div className={styles.rating_drop_down}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTEVALPEDS'
                                        entityKeyColumn='EVPNO'
                                        entityKeyValue={this.props.evpno}
                                        field='EVPHISTDEVGETDRESSEDCOMMENTS'
                                        placeholder='Comments'
                                    />
                                </div>
                            </>
                        }
                    </div>
                    <div className={styles.history_checkbox_rows}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPHISTDEVCUT' label='Cut' className={styles.checkbox_col} />
                        {this.props.histDevCut &&
                            <>
                                Age:
                                <DBIntField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGECUT'
                                    min={0}
                                    max={20}
                                    className={styles.colAge}
                                />
                                <DBDropDown
                                    className={styles.rating_drop_down}
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPHISTDEVAGETYPECUT'
                                    masterEntity='PTAGETYPES'
                                    masterEntityKeyColumn='ATNO'
                                    masterEntitySort='ATNO'
                                    masterEntityDisplay='ATDESC'
                                />
                                <div className={styles.rating_drop_down}>
                                    <DBTextField
                                        noteId={this.props.noteId}
                                        entity='PTEVALPEDS'
                                        entityKeyColumn='EVPNO'
                                        entityKeyValue={this.props.evpno}
                                        field='EVPHISTDEVCUTCOMMENTS'
                                        placeholder='Comments'
                                    />
                                </div>
                            </>
                        }
                    </div>
                </PatientCareCenterNoteSection>


                <PatientCareCenterNoteSection id='sub_med_equip' name='Equipment' level={2} allowCollapse={false}>
                    <label className={styles.label_full_top}>Please list any special equipment the child uses at home (alternative form of communication, adaptive seating, stander, walker, stroller, orthotics/braces, glasses, hearing aides, etc.):</label>
                    <div className={styles.textarea_row} id='sub_med_hist_comorb_allergy'>
                        <DBTextArea noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPEQUIPMENT' className={styles.textarea_col} />
                    </div>
                </PatientCareCenterNoteSection>



                <PatientCareCenterNoteSubjectiveFunctionalDeficits />
                <PatientCareCenterNoteSection id='sub_med_hist_past' name='Past Medical History' level={2} allowCollapse={false} className={styles.required}>
                    <div className={styles.textarea_row} id='sub_med_hist_comorb_allergy'>
                        <label className={styles.label_full_top}>Please list any surgeries and hospitalizations including the approximate date and reason: </label>
                    </div>
                    <div className={styles.textarea_row} id='sub_med_hist_comorb_allergy'>
                        <DBTextArea noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBHISTSURGERIES' className={styles.textarea_col} />
                    </div>

                    <div className={styles.textarea_row} id='sub_med_hist_comorb_allergy'>
                        <label className={styles.label_full_top}>Please describe any significant injuries for which the child has been treated (including fractures, dislocations, and sprains) with the approximate date of injury and treatment received.</label>
                    </div>
                    <div className={styles.textarea_row} id='sub_med_hist_comorb_allergy'>
                        <DBTextArea noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBHISTORYINJURIES' className={styles.textarea_col} />
                    </div>
                    <div className={styles.textarea_row}>
                        <label className={styles.label_col_half}>Does the child drink caffeinated beverages?</label>
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVALPEDS'
                            entityKeyColumn='EVPNO'
                            entityKeyValue={this.props.evpno}
                            field='EVPSUBHISTCAFFINE'
                            label='Yes'
                            selectedValue={true}
                            className={styles.radio_col_padding_left}
                        />
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVALPEDS'
                            entityKeyColumn='EVPNO'
                            entityKeyValue={this.props.evpno}
                            field='EVPSUBHISTCAFFINE'
                            label='No'
                            selectedValue={false}
                            className={styles.radio_col}
                        />
                    </div>
                    {this.props.drinksCaffine &&
                        <div className={styles.textarea_row}>
                            <div className={styles.padding_left}></div>
                            <label className={styles.label_col_req}>How many per day?</label>
                            <DBIntField
                                noteId={this.props.noteId}
                                entity='PTEVALPEDS'
                                entityKeyColumn='EVPNO'
                                entityKeyValue={this.props.evpno}
                                field='EVPSUBSHISTCAFFINEPERDAY'
                                className={styles.small_input}
                            />
                        </div>
                    }

                </PatientCareCenterNoteSection >

                <PatientCareCenterNoteSection id='subj_meds' name='Medications &amp; Supplements' level={1}>
                    <div className={styles.row}>
                        <label className={styles.col1_wide}>Is the patient taking any medications?</label>
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBMEDTAKING'
                            className={styles.col2}
                            selectedValue={true}
                            label='Yes'
                            onClick={(selectedVal) => this.handleMedsClick(selectedVal)}
                        />
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBMEDTAKING'
                            className={styles.col3}
                            selectedValue={false}
                            label='No'
                            onClick={(selectedVal) => this.handleMedsClick(selectedVal)}
                        />
                    </div>

                    {this.props.takingMeds &&
                        <div>
                            <div className={styles.row}>
                                <label className={styles.col1_wide}>Are meds for current condition?</label>
                                <DBRadioButton
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBMEDCURRENT'
                                    className={styles.col2}
                                    selectedValue={true}
                                    label='Yes'
                                />
                                <DBRadioButton
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBMEDCURRENT'
                                    className={styles.col3}
                                    selectedValue={false}
                                    label='No'
                                />
                            </div>

                            <div className={styles.row}>
                                <div className={styles.col1_top_req}>Medications:</div>
                                <DBTextArea
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBMEDS'
                                    className={styles.textarea}
                                />
                            </div>


                        </div>
                    }

                    <div className={styles.row}>
                        <div className={styles.col1_top}>Supplements:</div>
                        <DBTextArea
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBMEDSUPPLEMENT'
                            className={styles.textarea}
                        />
                    </div>

                </PatientCareCenterNoteSection>


                <PatientCareCenterNoteSection id='sub_med_hist_comorb' name='Comorbidity' level={2} allowCollapse={false} className={styles.required}>
                    <label className={styles.label_full_top}>Has the child ever been diagnosed as having any of the following? If so, please explain.</label>
                    <div className={styles.checkbox_row}>
                        <span className={styles.label_col} />
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMNONE' label='None' className={styles.checkbox_col}
                            onClick={(event) => this.handleClick(event)}
                        />
                    </div>
                    {this.props.comorbNone === false &&
                        <div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMADHD' label='ADD/ADHD' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMHEADACHES' label='Headaches/migraines' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMALLERGIES' label='Allergies' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMHEARING' label='Hearing impairment' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMANEMIA' label='Anemia' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMHEART' label='Heart Problems' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMANXIETY' label='Anxiety' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMHIGHBLOOD' label='High blood pressure' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMARTHITIS' label='Arthritis' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMHYPERTONIA' label='Hypertonia/high tone' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMASTHMA' label='Asthma/breathing problems' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMHYPOTONIA' label='Hypotonia/low tone' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMAUTISM' label='Autism' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMKIDNEY' label='Kidney disease' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMCANCER' label='Cancer' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMMUSCULAR' label='Muscular dystrophy' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMCEREBRAL' label='Cerebral palsy' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMOTHER' label='Other' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMCONSTIPATION' label='Constipation' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMREFLUX' label='Reflux' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMDEPRESSION' label='Depression' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMSPINA' label='Spina bifida' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMDIABETES' label='Diabetes' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMSTROKE' label='Stroke/brain bleed' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMEARINFECT' label='Ear Infections' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMTHYROID' label='Thyroid problems' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.checkbox_row}>
                                <span className={styles.label_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMEPILEPSY' label='Epilepsy/seizures' className={styles.checkbox_col} />
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMVISION' label='Vision Impairment' className={styles.checkbox_col} />
                            </div>

                            <div className={styles.checkbox_row}>
                                <label className={this.props.comobOther ? styles.label_col_top_req : styles.label_col_top}>Other details:</label>
                                <DBTextArea noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCOMOTHERDETAILS' className={this.props.comobOther ? styles.textarea_col_req : styles.textarea_col} />
                            </div>

                            <div className={styles.checkbox_row}></div>

                            {this.props.comorbAllergies &&
                                <div className={styles.textarea_row} id='sub_med_hist_comorb_allergy'>
                                    <label className={styles.label_col_req_top}>Allergies:</label>
                                    <DBTextArea noteId={this.props.noteId} entity='PTEVAL' entityKeyColumn='EVNO' entityKeyValue={this.props.evno} field='EVSUBMEDCOMALLERGY' className={styles.textarea_col} />
                                </div>
                            }

                            <div className={styles.checkbox_row}></div>
                        </div>


                    }

                </PatientCareCenterNoteSection>
            </div >
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);

    let evpno = Object.keys(state.entities.notes.PTEVALPEDS)
        //peds info
        .find(key => (state.entities.notes.PTEVALPEDS[key].EVPEVNO === evno));

    let drinksCaffine = state.entities.notes.PTEVALPEDS[evpno].EVPSUBHISTCAFFINE ? true : false;

    let prevTreat = state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVTREATEDPREV;
    let earlyInter = state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVEARLYINT;
    let hosptial = state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVHOSPITAL;
    let school = state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVSCHOOL;
    let otherTher = state.entities.notes.PTEVALPEDS[evpno].EVPHISTORYPREVOTHER;

    let histDevSit = state.entities.notes.PTEVALPEDS[evpno].EVPHISTDEVSIT;
    let histDevRoll = state.entities.notes.PTEVALPEDS[evpno].EVPHISTDEVROLL;
    let histDevCrawl = state.entities.notes.PTEVALPEDS[evpno].EVPHISTDEVCRAWL;
    let histDevStand = state.entities.notes.PTEVALPEDS[evpno].EVPHISTDEVSTAND;
    let histDevWalk = state.entities.notes.PTEVALPEDS[evpno].EVPHISTDEVWALK;
    let histDevRun = state.entities.notes.PTEVALPEDS[evpno].EVPHISTDEVRUN;
    let histDevWords = state.entities.notes.PTEVALPEDS[evpno].EVPHISTDEVPUTWORDS;
    let histDevRead = state.entities.notes.PTEVALPEDS[evpno].EVPHISTDEVREAD;
    let histDevFeed = state.entities.notes.PTEVALPEDS[evpno].EVPHISTDEVFEEDSELF;
    let histDevColor = state.entities.notes.PTEVALPEDS[evpno].EVPHISTDEVCOLOR;
    let histDevDressed = state.entities.notes.PTEVALPEDS[evpno].EVPHISTDEVGETDRESSED;
    let histDevCut = state.entities.notes.PTEVALPEDS[evpno].EVPHISTDEVCUT;
    let comobOther = state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMOTHER ? state.entities.notes.PTEVALPEDS[evpno].EVPSUBMEDCOMOTHER : false;




    return {
        noteId: noteId,
        evno: evno,
        comorbNone: state.entities.notes.PTEVAL[evno].EVSUBMEDCOMNONE ? state.entities.notes.PTEVAL[evno].EVSUBMEDCOMNONE : false,
        comorbAllergies: state.entities.notes.PTEVAL[evno].EVSUBMEDCOMALLERGIES ? state.entities.notes.PTEVAL[evno].EVSUBMEDCOMALLERGIES : false,
        takingMeds: state.entities.notes.PTEVAL[evno].EVSUBMEDTAKING ? state.entities.notes.PTEVAL[evno].EVSUBMEDTAKING : false,
        evpno,
        drinksCaffine,
        prevTreat,
        earlyInter,
        hosptial,
        school,
        otherTher,
        histDevSit,
        histDevRoll,
        histDevCrawl,
        histDevStand,
        histDevWalk,
        histDevRun,
        histDevWords,
        histDevRead,
        histDevFeed,
        histDevColor,
        histDevDressed,
        histDevCut,
        comobOther
    };
}

const connectedPatientCareCenterNoteSubjectiveMedHistoryPeds = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectiveMedHistoryPeds);
export { connectedPatientCareCenterNoteSubjectiveMedHistoryPeds as PatientCareCenterNoteSubjectiveMedHistoryPeds };

